'use client';
import React from 'react';
import { useIntersectionObserver } from '@repo/ui/src/hooks/useIntersectionObserver';
import { classNames } from '@repo/ui/src/utils/classNames';
import { OrderDetailProps } from '@views/OrderDetail/OrderDetailContent';
import styles from './ShipmentStatus.module.css';

export type ShipmentStatusText = Pick<OrderDetailProps, 'statuses'>;

export interface ShipmentStatusProps extends ShipmentStatusText {
  currentStatus: ShipmentStatuses;
}

export enum ShipmentStatuses {
  digital = -1,
  processing = 0,
  preparing = 1,
  shipped = 2,
  delivered = 3,
}

const ShipmentStatus = ({ statuses, currentStatus }: ShipmentStatusProps) => {
  const ref = React.useRef<HTMLUListElement>(null);
  const entry = useIntersectionObserver(ref, { threshold: 1 });

  return (
    <div className="tw-hidden sm:tw-block tw-w-full tw-px-4 tw-pb-10 tw-max-w-4xl tw-mx-auto">
      <ul
        className={classNames(
          "tw-relative tw-grid tw-grid-flow-col tw-justify-between tw-list-none tw-p-0 tw-z-10 after:tw-content-['_'] after:tw-block  after:tw-h-px after:tw-absolute after:tw-w-11/12 after:tw-left-4 after:tw-top-[28px] after:-tw-z-10",
          styles.shippingStatusContainer,
          entry?.isIntersecting && styles.active,
        )}
        ref={ref}
      >
        {statuses.map(({ title }, index) => (
          <li key={title} className="tw-grid tw-justify-items-center tw-relative">
            <span
              className={classNames(
                'tra-text-web-heading-7 tw-grid tw-place-content-center tw-rounded-full tw-text-white tw-w-14 tw-h-14',
                currentStatus >= index ? styles.shippingStatus : 'tw-bg-warm-400',
                entry?.isIntersecting && styles.active,
              )}
              aria-label={title}
            >
              {index + 1}
            </span>
            <p className="tra-text-web-body-l tw-font-bold tw-absolute -tw-bottom-[2em] tw-left-1/2 -tw-translate-x-1/2 tw-whitespace-nowrap">
              {title}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ShipmentStatus;
